import React from 'react';
import './Bundles.scss';
import Bundle from './Bundle/Bundle';

/**
 * Renders bundles module
 * @param {string} title
 * @param {array} bundles
 * @param {function} addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const Bundles = ({ title, bundles, addToCart }) => {
  const renderBundles = (bundles) =>
    bundles.map((bundle) => <Bundle {...bundle} addToCart={addToCart} />);

  return (
    <div className="c-bundles">
      <div className="c-bundles__inner">
        <div className="c-bundles__title h2-roobert">
          <h2>{title}</h2>
        </div>
        {renderBundles(bundles)}
      </div>
    </div>
  );
};

export default Bundles;
